import distance from '@turf/distance';
import { convertLength, point } from '@turf/helpers';
export const getDistanceToClinics = (clinic, currentCoords) => {
    if (!clinic.coordinates)
        return;
    const from = point([currentCoords.longitude, currentCoords.latitude]);
    const to = point([clinic.coordinates.lng, clinic.coordinates.lat]);
    return distance(from, to, { units: 'kilometers' });
};
/**
 * @param distance - distance will be converted
 * @returns JSX Element formatted to either meter or km
 */
export const convertDistanceToUnit = (distance) => {
    const distanceToMeter = convertLength(distance, 'kilometers', 'meters').toFixed(0);
    return distance < 1 ? `${distanceToMeter} m` : `${distance.toFixed(1)} km`;
};
export const clinicsWithDistance = (currentCoords, clinics) => clinics.map((clinic) => {
    const distance = getDistanceToClinics(clinic, currentCoords);
    return {
        ...clinic,
        distance,
    };
});
